import React from 'react';
// import clerk from '../utils/clerk';
import axios from 'axios';

import { getToken } from '../hooks/AuthProvider';
import { authClient } from '../hooks/authClient';
// import { Logtail } from "@logtail/browser";
// const logtail = new Logtail("mgGWiuxjsNuyKtNhh9CtXaYm");

let shakaPolyfillInstalled = false;
function ensureShakaPolyfills() {
    if (shakaPolyfillInstalled) return;
    // @ts-ignore
    shaka.polyfill.installAll();
    shakaPolyfillInstalled = true;
}

type props = {
    wmanifestURI: string;
    fmanifestURI: string;
    contentID: string;
    type: string;
    contentWidth: number;
    contentHeight: number;
    ogname: string;
    name: string | null;
    prevAccessed: boolean;
    authorizationToken?: string;
}

type state = {
    player: any;
    manifestURI: string;
    username: string;
    cWidth: number;
    cHeight: number;
    previouslyAccessed: boolean;
    watched: boolean;
    revealed: boolean;
    isRevealing: boolean;
    retryCount: number;
    streamSessionId: string | null;
    streamError: string | null;
    isLoading: boolean;
}

export default class ShakaPlayerComponent extends React.PureComponent<props, state> {
    private player: any;
    private canvas: any;
    private videoDiv: any;
    private element: HTMLDivElement | null = null;
    private playerInstance: any = null;
    private currentManifestUrl: string = '';
    private heartbeatInterval: ReturnType<typeof setInterval> | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            player: null,
            manifestURI: '',
            username: 'demoUser ...',
            cWidth: 300,
            cHeight: 150,
            previouslyAccessed: false,
            watched: false,
            revealed: props.type === 'image' ? props.prevAccessed : true,
            isRevealing: false,
            retryCount: 0,
            streamSessionId: null,
            streamError: null,
            isLoading: true,
        }
        this.loadVideo = this.loadVideo.bind(this);
        this.canvas = React.createRef();
        this.player = React.createRef();
        this.videoDiv = React.createRef();
    }

    handleReveal = async () => {
        // Set loading state
        this.setState({ isRevealing: true });

        try {
            // Track content consumption FIRST before loading content
            await axios.post(`${process.env.REACT_APP_API_URL}api/v1/content/play`, {
                userID: localStorage.getItem('userID'),
                contentID: this.props.contentID,
            }, {
                headers: {
                    'x-auth-token': getToken()
                }
            });

            console.log('Content consumption recorded');

            // Only after successful consumption tracking, reveal and load the video
            this.setState({ revealed: true, isRevealing: false }, () => {
                // Now load the video content
                if (this.player) {
                    this.loadVideo(this.player, this.props.wmanifestURI, this.props.fmanifestURI, this.props.contentID);
                }
            });
        } catch (error) {
            console.error('Failed to record content consumption:', error);
            this.setState({ isRevealing: false });
            // Don't reveal content if tracking failed - this prevents bypass
        }
    }

    refreshToken = async (): Promise<void> => {
        try {
            await authClient.getSession({
                fetchOptions: {
                    onSuccess: (ctx) => {
                        const jwt = ctx.response.headers.get("set-auth-jwt");
                        if (jwt) {
                            localStorage.setItem("GCJWT", jwt);
                            console.log('Token refreshed successfully');
                        }
                    },
                    onResponse: (ctx) => {
                        const authToken = ctx.response.headers.get("set-auth-token");
                        const jwt = ctx.response.headers.get("set-auth-jwt");
                        if (authToken) {
                            localStorage.setItem("GCToken", authToken);
                        }
                        if (jwt) {
                            localStorage.setItem("GCJWT", jwt);
                            console.log('Token refreshed successfully');
                        }
                    }
                },
            });
        } catch (error) {
            console.error('Failed to refresh token:', error);
            throw error;
        }
    }

    retryOnDrmUnavailable = async (): Promise<void> => {
        if (this.state.retryCount >= 3) {
            console.error('Max retry attempts (3) reached for error 6001. Stopping retries.');
            return;
        }

        const newRetryCount = this.state.retryCount + 1;
        console.log(`Retrying DRM setup (attempt ${newRetryCount}/3) - destroying and recreating player`);
        this.setState({ retryCount: newRetryCount });

        try {
            if (this.playerInstance) {
                await this.playerInstance.destroy();
                this.playerInstance = null;
            }

            await new Promise(resolve => setTimeout(resolve, 1000));

            await this.loadVideo(this.player, this.props.wmanifestURI, this.props.fmanifestURI, this.props.contentID, true);
            console.log('DRM retry successful');
        } catch (error) {
            console.error(`DRM retry attempt ${newRetryCount} failed:`, error);
            if (newRetryCount >= 3) {
                console.error('All DRM retry attempts exhausted for error 6001');
            }
        }
    }

    retryOnLicenseFailure = async (playerInstance: any, url: string): Promise<void> => {
        if (this.state.retryCount >= 3) {
            console.error('Max retry attempts (3) reached for error 6007. Stopping retries.');
            this.setState({ streamError: 'A current session is active, please close the session on that device and refresh the page.', isLoading: false });
            return;
        }

        const newRetryCount = this.state.retryCount + 1;
        console.log(`Retrying load with fresh token (attempt ${newRetryCount}/3)`);
        this.setState({ retryCount: newRetryCount });

        try {
            await this.refreshToken();
            await new Promise(resolve => setTimeout(resolve, 500));
            await playerInstance.load(url);
            console.log('License retry successful');
        } catch (error) {
            console.error(`License retry attempt ${newRetryCount} failed:`, error);
            if (newRetryCount >= 3) {
                console.error('All license retry attempts exhausted for error 6007');
                this.setState({ streamError: 'A current session is active, please close the session on that device and refresh the page.', isLoading: false });
            }
        }
    }

    componentDidMount(): void {
        // For images: only load video if already revealed (previously accessed)
        // This prevents content from being loaded before consumption is tracked
        if (this.props.type === 'image' && !this.state.revealed) {
            // Don't load - wait for user to click reveal
            return;
        }

        // For videos or already-revealed images, load normally
        if (this.player && ((this.props.wmanifestURI !== null || this.props.fmanifestURI !== null) || (this.props.wmanifestURI !== undefined || this.props.fmanifestURI !== undefined) || (this.props.wmanifestURI !== '' || this.props.fmanifestURI !== '')) && (this.props.contentID !== null || this.props.contentID !== undefined || this.props.contentID !== '')) {
            this.loadVideo(this.player, this.props.wmanifestURI, this.props.fmanifestURI, this.props.contentID);
        }
    }

    async loadVideo(player: any, widevine: string, fairplay: string, contentID: string, isRetry: boolean = false) {
        if (!isRetry) {
            this.setState({ retryCount: 0 });
        }

        this.setState({ isLoading: true });

        if (player.current) {
            player.current.removeEventListener('loadeddata', this.handleVideoLoaded);
            player.current.addEventListener('loadeddata', this.handleVideoLoaded);
        }

        console.log(widevine);

        const authToken = this.props.authorizationToken || '';

        ensureShakaPolyfills();

        // @ts-ignore
        if (shaka.Player.isBrowserSupported()) {
            if (window.navigator.appVersion.indexOf('Win') !== -1) {
                // console.log('windows');
                // WIDEVINE ...
                const url = widevine;
                // @ts-ignore
                // var playerInstance = new shaka.Player();
                const playerInstance = new shaka.Player(player.current);
                // Store player instance and URL for retry access
                this.playerInstance = playerInstance;
                this.currentManifestUrl = url;
                // await playerInstance.attach(player.current);

                console.log({os: 'windows', widevine: widevine, fairplay: fairplay, contentID: contentID});

                playerInstance.configure({
                    drm: {
                        servers: {
                            'com.widevine.alpha': `${process.env.REACT_APP_API_URL}api/v1/widevine?contentID=${contentID}`
                        },
                        advanced: {
                            'com.widevine.alpha': {
                                videoRobustness: 'SW_SECURE_DECODE',
                                audioRobustness: 'SW_SECURE_CRYPTO',
                            }
                        }
                    },
                });

                if (playerInstance !== null && this.videoDiv.current !== null && this.player.current !== null && this.props.type !== 'image') {
                    // @ts-ignore
                    const ui = new shaka.ui.Overlay(playerInstance, this.videoDiv.current, this.player.current);
                    const controls = ui.getControls();

                    ui.configure({
                        'overflowMenuButtons' : ['quality', 'loop'],
                    })
                }

                playerInstance.getNetworkingEngine().registerRequestFilter(function (type: any, request: any) {
                    // console.log('Request filter', type, request);
                    // @ts-ignore
                    if (type === shaka.net.NetworkingEngine.RequestType.SEGMENT || type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
                        request.headers['Authorization'] = `Bearer ${authToken}`;
                    }
                    // @ts-ignore
                    if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                        request.headers['x-auth-token'] = getToken();
                    }
                })

                playerInstance.getNetworkingEngine().registerResponseFilter((type: any, response: any) => {
                    // @ts-ignore
                    if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                        const sid = response.headers?.['x-stream-session-id'];
                        if (sid) {
                            this.setState({ streamSessionId: sid });
                        }
                    }
                });

                if (player.current !== null) {
                    player.current.addEventListener('playing', this.handlePlaying);
                }

                playerInstance.addEventListener('error', async (event: any) => {
                    const errorCode = event.detail?.code;
                    const httpStatus = event.detail?.data?.[1] ?? event.detail?.data?.[0];
                    console.error('Error code', errorCode, 'object', event.detail);

                    if (errorCode === 6007 && httpStatus === 403) {
                        this.setState({ streamError: 'A current session is active, please close the session on that device and refresh the page.', isLoading: false });
                        return;
                    }
                    
                    if (errorCode === 6001 && this.state.retryCount < 3) {
                        await this.retryOnDrmUnavailable();
                    } else if (errorCode === 6007 && this.state.retryCount < 3) {
                        await this.retryOnLicenseFailure(playerInstance, url);
                    }
                });

                playerInstance.addEventListener('loaded', () => {
                    const variantTracks = playerInstance.getVariantTracks();
                    var resolutions = variantTracks.map((track: any) => track.height ? `${track.height}p` : 'Unknown Resolution');

                    console.log('Available resolutions:', resolutions);
                })

                try {
                    await playerInstance.load(url);
                } catch (error) {
                    console.error('Error code ', error);
                    this.setState({ isLoading: false });
                }
            } else {
                // @ts-ignore
                shaka.polyfill.PatchedMediaKeysApple?.install()

                // @ts-ignore
                // shaka.log.setLevel(shaka.log.Level.V2);

                if (navigator.userAgent.includes('Chrome')) {
                    const url = widevine;
                    // @ts-ignore
                    // var playerInstance = new shaka.Player();
                    const playerInstance = new shaka.Player(player.current);
                    // Store player instance and URL for retry access
                    this.playerInstance = playerInstance;
                    this.currentManifestUrl = url;
                    // await playerInstance.attach(player.current);

                    console.log({os: 'windows', widevine: widevine, fairplay: fairplay, contentID: contentID});

                    playerInstance.configure({
                        drm: {
                            servers: {
                                'com.widevine.alpha': `${process.env.REACT_APP_API_URL}api/v1/widevine?contentID=${contentID}`
                            },
                            advanced: {
                                'com.widevine.alpha': {
                                    videoRobustness: 'SW_SECURE_DECODE',
                                    audioRobustness: 'SW_SECURE_CRYPTO',
                                }
                            }
                        },
                    });

                    if (playerInstance !== null && this.videoDiv.current !== null && this.player.current !== null && this.props.type !== 'image') {
                        // @ts-ignore
                        const ui = new shaka.ui.Overlay(playerInstance, this.videoDiv.current, this.player.current);
                        const controls = ui.getControls();

                        ui.configure({
                            'overflowMenuButtons' : ['quality', 'loop'],
                        })
                    }

                    playerInstance.getNetworkingEngine().registerRequestFilter(function (type: any, request: any) {
                        // @ts-ignore
                        if (type === shaka.net.NetworkingEngine.RequestType.SEGMENT || type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
                            request.headers['Authorization'] = `Bearer ${authToken}`;
                        }
                        // @ts-ignore
                        if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                            request.headers['x-auth-token'] = getToken();
                        }
                    })

                    playerInstance.getNetworkingEngine().registerResponseFilter((type: any, response: any) => {
                        // @ts-ignore
                        if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                            const sid = response.headers?.['x-stream-session-id'];
                            if (sid) {
                                this.setState({ streamSessionId: sid });
                            }
                        }
                    });

                    if (player.current !== null) {
                        player.current.addEventListener('playing', this.handlePlaying);
                    }

                    playerInstance.addEventListener('error', async (event: any) => {
                        const errorCode = event.detail?.code;
                        const httpStatus = event.detail?.data?.[1] ?? event.detail?.data?.[0];
                        console.error('Error code', errorCode, 'object', event.detail);

                        if (errorCode === 6007 && httpStatus === 403) {
                            this.setState({ streamError: 'A current session is active, please close the session on that device and refresh the page.', isLoading: false });
                            return;
                        }
                        
                        if (errorCode === 6001 && this.state.retryCount < 3) {
                            await this.retryOnDrmUnavailable();
                        } else if (errorCode === 6007 && this.state.retryCount < 3) {
                            await this.retryOnLicenseFailure(playerInstance, url);
                        }
                    });

                    playerInstance.addEventListener('loaded', () => {
                        const variantTracks = playerInstance.getVariantTracks();
                        var resolutions = variantTracks.map((track: any) => track.height ? `${track.height}p` : 'Unknown Resolution');

                        console.log('Available resolutions:', resolutions);
                    })

                    try {
                        await playerInstance.load(url);
                    } catch (error) {
                        console.error('Error code ', error);
                        this.setState({ isLoading: false });
                    }
                } else {
                    const url = fairplay;
                    // @ts-ignore
                    // var playerInstance = new shaka.Player(player.current);
                    const playerInstance = new shaka.Player(player.current);
                    // Store player instance and URL for retry access
                    this.playerInstance = playerInstance;
                    this.currentManifestUrl = url;
                    // await playerInstance.attach(player.current);

                    playerInstance.getNetworkingEngine().clearAllRequestFilters();

                    playerInstance.getNetworkingEngine().registerRequestFilter(function (type: any, request: any) {
                        console.log('Request filter', type, request);
                        // @ts-ignore
                        if (type === shaka.net.NetworkingEngine.RequestType.SEGMENT || type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
                            request.headers['Authorization'] = `Bearer ${authToken}`;
                        }
                        // @ts-ignore
                        if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                            request.headers['x-auth-token'] = getToken();
                        }
                        // @ts-ignore
                        if (type != shaka.net.NetworkingEngine.RequestType.LICENSE) {
                            return;
                        }

                        const originalPayload = new Uint8Array(request.body);
                        // @ts-ignore
                        const base64Payload = shaka.util.Uint8ArrayUtils.toStandardBase64(originalPayload);
                        request.headers['Content-Type'] = 'text/plain; charset=utf-8';
                        // @ts-ignore
                        request.body = shaka.util.StringUtils.toUTF8(base64Payload);
                        request.uris = [`${process.env.REACT_APP_API_URL}api/v1/fairplay?contentID=${contentID}`];
                    });

                    playerInstance.getNetworkingEngine().registerResponseFilter((type: any, response: any) => {
                        // @ts-ignore
                        if (type == shaka.net.NetworkingEngine.RequestType.LICENSE) {
                            const sid = response.headers?.['x-stream-session-id'];
                            if (sid) {
                                this.setState({ streamSessionId: sid });
                            }
                            // @ts-ignore
                            const responseText = shaka.util.StringUtils.fromUTF8(response.data).trim();
                            var newArr = JSON.parse(responseText);
                            // @ts-ignore
                            response.data = shaka.util.Uint8ArrayUtils.fromBase64(newArr.data).buffer;
                        }
                    });

                    var cert = await fetch(`${process.env.REACT_APP_API_URL}api/v1/fairplay/certificate`);
                    const C = await cert.arrayBuffer();

                    playerInstance.configure({
                        drm: {
                            servers: {
                                'com.apple.fps': `${process.env.REACT_APP_API_URL}api/v1/fairplay?contentID=${contentID}`
                            },
                            advanced: {
                                'com.apple.fps': {
                                    serverCertificate: new Uint8Array(C)
                                }
                            },
                        },
                        streaming: {
                            useNativeHlsForFairPlay: true, // Use native HLS on Safari
                        }
                    });

                    player.current.addEventListener('playing', this.handlePlaying);

                    playerInstance.addEventListener('error', async (event: any) => {
                        const errorCode = event.detail?.code;
                        const httpStatus = event.detail?.data?.[1] ?? event.detail?.data?.[0];
                        console.error('Error code', errorCode, 'object', event.detail);

                        if (errorCode === 6007 && httpStatus === 403) {
                            this.setState({ streamError: 'A current session is active, please close the session on that device and refresh the page.', isLoading: false });
                            return;
                        }
                        
                        if (errorCode === 6001 && this.state.retryCount < 3) {
                            await this.retryOnDrmUnavailable();
                        } else if (errorCode === 6007 && this.state.retryCount < 3) {
                            await this.retryOnLicenseFailure(playerInstance, url);
                        }
                    });

                    if (this.props.type !== 'image') {
                        // @ts-ignore
                        const ui = new shaka.ui.Overlay(playerInstance, this.videoDiv.current, this.player.current);
                        const controls = ui.getControls();

                        ui.configure({
                            'overflowMenuButtons' : ['quality', 'loop'],
                        })
                    }

                    const tracks = playerInstance.getVariantTracks();
                    console.log("Available tracks:", tracks);

                    // Force a specific resolution
                    const target = tracks.find((t: any) => t.height === 720); // or 1080, 1440...
                    if (target) {
                        playerInstance.selectVariantTrack(target, /* clearBuffer */ true);
                    }

                    playerInstance.addEventListener('loaded', () => {
                        const variantTracks = playerInstance.getVariantTracks();
                        console.log(variantTracks);
                        var resolutions = variantTracks.map((track: any) => track.height ? `${track.height}p` : 'Unknown Resolution');

                        console.log('Available resolutions:', resolutions);
                    })

                    try {
                        await playerInstance.load(url);
                    } catch (error) {
                        console.error('Error code ', error);
                        this.setState({ isLoading: false });
                    }
                }
            }
        }
    }

    startHeartbeat = () => {
        if (this.heartbeatInterval) return;

        this.heartbeatInterval = setInterval(async () => {
            const sid = this.state.streamSessionId;
            if (!sid) return;

            try {
                await axios.post(`${process.env.REACT_APP_API_URL}api/v1/stream/heartbeat`, {
                    sessionId: sid,
                }, {
                    headers: { 'x-auth-token': getToken() },
                });
            } catch (err) {
                console.error('Stream heartbeat failed:', err);
            }
        }, 30_000);
    }

    sendStreamEnd = () => {
        const sid = this.state.streamSessionId;
        if (!sid) return;

        const payload = JSON.stringify({ sessionId: sid });
        const token = getToken();
        const url = `${process.env.REACT_APP_API_URL}api/v1/stream/end`;

        fetch(url, {
            method: 'POST',
            body: payload,
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': token || '',
            },
            keepalive: true,
        }).catch(() => {});
    }

    handleBeforeUnload = () => {
        this.sendStreamEnd();
    }

    handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            this.sendStreamEnd();
        }
    }

    handlePageHide = () => {
        this.sendStreamEnd();
    }

    handleVideoLoaded = () => {
        this.setState({ isLoading: false });
    }

    handlePlaying = async () => {
        console.log('Now Playing Content');

        this.startHeartbeat();
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('pagehide', this.handlePageHide);
    
        if (!this.state.watched) {
            if (!this.props.prevAccessed) {
                await axios.post(`${process.env.REACT_APP_API_URL}api/v1/content/play`, {
                    userID: localStorage.getItem('userID'),
                    contentID: this.props.contentID,
                }, {
                    headers: {
                        'x-auth-token': getToken()
                    }
                }).then(res => {
                    console.log('Content play recorded:', res.data);
                });
            }
            this.setState({ watched: true });
        }
    };

    componentWillUnmount(): void {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('pagehide', this.handlePageHide);
        this.sendStreamEnd();

        if (this.player.current) {
            this.player.current.removeEventListener('playing', this.handlePlaying);
            this.player.current.removeEventListener('loadeddata', this.handleVideoLoaded);
        }
        if (this.playerInstance) {
            this.playerInstance.destroy().catch((e: any) => {
                console.error('Error destroying player:', e);
            });
            this.playerInstance = null;
        }
    }

    render() {
        const containerAspectRatio = this.props.contentWidth && this.props.contentHeight
            ? (this.props.contentHeight > this.props.contentWidth
                ? '16 / 9'
                : `${this.props.contentWidth} / ${this.props.contentHeight}`)
            : '16 / 9';

        const errorContainer = this.state.streamError && (
            <div
                style={{
                    width: '100%',
                    aspectRatio: containerAspectRatio,
                    backgroundColor: '#000',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
                    <svg className="h-12 w-12 text-red-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    <p className="text-white text-center px-6 font-medium max-w-md">{this.state.streamError}</p>
                </div>
            </div>
        );

        return <div className="flex relative w-full">
            {this.state.streamError ? (
                errorContainer
            ) : (
            <div ref={this.videoDiv} className="relative w-full">
                {this.props.type === 'image' ? (
                    <div
                        style={{
                            width: '100%',
                            aspectRatio: containerAspectRatio,
                            backgroundColor: '#000',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            position: 'relative',
                        }}
                    >
                        {!this.state.revealed ? (
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 animate-pulse" />
                                <button
                                    className="relative z-10 flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                    onClick={this.handleReveal}
                                    disabled={this.state.isRevealing}
                                >
                                    {this.state.isRevealing ? (
                                        <>
                                            <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                            </svg>
                                            <span>Loading...</span>
                                        </>
                                    ) : (
                                        <>
                                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            <span>Reveal Content</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        ) : (
                            <>
                                <div
                                    className={`absolute inset-0 z-30 transition-opacity duration-500 ${this.state.isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                                >
                                    <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 animate-pulse" />
                                </div>
                                <video
                                    id="video"
                                    ref={this.player}
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    controls={false}
                                    autoPlay
                                    loop
                                    muted
                                />
                            </>
                        )}
                    </div>
                ) : (
                    <div
                        style={{
                            width: '100%',
                            aspectRatio: containerAspectRatio,
                            backgroundColor: '#000',
                            position: 'relative',
                        }}
                    >
                        <div
                            className={`absolute inset-0 z-30 transition-opacity duration-500 ${this.state.isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                        >
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 animate-pulse" />
                        </div>
                        <video
                            id="video"
                            ref={this.player}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                )}
            </div>
            )}
            <canvas ref={this.canvas} width={this.state.cWidth} height={this.state.cHeight} id="ctest" style={{pointerEvents: 'none', position: 'absolute', zIndex: 9}} className="ml-2" />
        </div>
    }
}